export const theme = {
    primary: 'rgb(129,205,83)',
    secondary: 'rgb(55,146,62)',
    background: '#fff',
    text: '#000',
}
